var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "renewalPlanSwitchModal",
      "modal-class": "plan-renewable-modal",
      "centered": "",
      "size": "lg",
      "hide-footer": "",
      "hide-header-close": ""
    },
    on: {
      "shown": _vm.getCurrentPlan
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "view-clients-header"
        }, [_c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }])
  }, [_c('b-container', {
    ref: "memberDocContainer",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "view-clients-modal-content"
  }, [_c('div', {
    staticClass: "col-xl-12"
  }, [_c('div', {
    staticClass: "notice"
  }, [_c('h2', [_vm._v("Open Enrollment Plan Change Eligible")]), _c('p', {
    staticClass: "mb-3"
  }, [_vm._v(" Your plan is eligible to change for Jan 1, 2026, you can keep your existing plan or choose to change to another plan. Deadline to change is 12/15/2025. If you do not choose a new plan, your current plan will renew at the renewal rate. ")]), _vm.loadingPlan ? _c('ul', {
    staticClass: "text-center mt-2"
  }, [_c('strong', [_vm._v("Loading...")])]) : _c('ul', [_c('dashboard-enrollment-current-plan', {
    attrs: {
      "current-plan": _vm.currentPlan
    },
    on: {
      "update:currentPlan": function updateCurrentPlan($event) {
        _vm.currentPlan = $event;
      },
      "update:current-plan": function updateCurrentPlan($event) {
        _vm.currentPlan = $event;
      }
    }
  }), _c('dashboard-enrollment-renewal-plan', {
    attrs: {
      "current-plan": _vm.currentPlan,
      "member": _vm.member
    },
    on: {
      "update:currentPlan": function updateCurrentPlan($event) {
        _vm.currentPlan = $event;
      },
      "update:current-plan": function updateCurrentPlan($event) {
        _vm.currentPlan = $event;
      }
    }
  })], 1)])])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }